import './contentbox.css';
import './contentbuilder.css';

/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import ContentBox from '@innovastudio/contentbox';

import { uploadBase64Image, uploadFileStatic } from '../../api';
import { addExternalScripts, addExternalStyles } from '../../util';
import EditPanel from './editpanel';

class BuilderControl extends Component {
  constructor(props) {
    super(props);

    this.saveContent = this.saveContent.bind(this);
    this.saveContentAndFinish = this.saveContentAndFinish.bind(this);
  }

  startEditing(iframe) {
    addExternalStyles([
      '/assets/minimalist-blocks/content-tailwind.css',
      '/assets/frameworks/tailwindcss/styles.css',
      '/assets/minimalist-blocks/content.css',
      '/box/box-flex.css',
      '/assets/scripts/glide/css/glide.core.css',
      '/assets/scripts/glide/css/glide.theme.css',
      '/assets/scripts/navbar/navbar.css',
    ]);

    // Load language file first
    this.loadLanguageFile('contentbox/lang/en.js', () => {
      // Then init the ContentBox
      this.obj = new ContentBox({
        wrapper: '.is-wrapper',
        previewURL: 'preview.html',

        iframe: iframe ? iframe : false,

        zoom: 1,
        slider: 'glide',
        navbar: true,

        // To enable AI Assistant
        sendCommandUrl: '/sendcommand',

        // Open asset/file browser (can be replaced with your own asset/file manager application)
        imageSelect: '/assets.html',
        videoSelect: '/assets.html',
        audioSelect: '/assets.html',
        fileSelect: '/assets.html',
        mediaSelect: '/assets.html', // for image & video

        // Upload using AJAX Method:
        onUploadCoverImage: (e) => {
          this.uploadFile(e, (response) => {
            const uploadedImageUrl = response.url; // get saved image url
            this.obj.boxImage(uploadedImageUrl); // change cover image
          });
        },
        onImageUpload: (e) => {
          this.uploadFile(e, (response) => {
            const uploadedFileUrl = response.url;
            this.obj.returnUrl(uploadedFileUrl);
          });
        },
        onVideoUpload: (e) => {
          this.uploadFile(e, (response) => {
            const uploadedFileUrl = response.url;
            this.obj.returnUrl(uploadedFileUrl);
          });
        },
        onAudioUpload: (e) => {
          this.uploadFile(e, (response) => {
            const uploadedFileUrl = response.url;
            this.obj.returnUrl(uploadedFileUrl);
          });
        },
        onMediaUpload: (e) => {
          this.uploadFile(e, (response) => {
            const uploadedImageUrl = response.url;
            this.obj.returnUrl(uploadedImageUrl);
          });
        },
        onFileUpload: (e) => {
          this.uploadFile(e, (response) => {
            const uploadedFileUrl = response.url;
            this.obj.returnUrl(uploadedFileUrl);
          });
        },

        onChange: () => {
          //Auto Save
          const throttleDelay = 2 * 60 * 1000;
          if (!this.isThrottled) {
            this.isThrottled = true;
            this.saveContent();
            this.timeoutId = setTimeout(() => {
              this.isThrottled = false;
            }, throttleDelay);
          } else {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
              this.saveContent();
              this.isThrottled = false;
            }, throttleDelay);
          }
        },

        templates: [
          {
            url: 'assets/simplestart/templates.js',
            path: 'assets/simplestart/',
            pathReplace: [],
          },
          {
            url: 'assets/quickstart/templates.js',
            path: 'assets/quickstart/',
            pathReplace: [],
          },
          {
            url: 'assets/animated/templates.js', // Load the new Animated template set
            path: 'assets/animated/',
            pathReplace: [],
          },
        ],

        contentStyles: {
          data: {
            categories: [
              { id: -1, desc: 'ALL' },
              { id: 1, desc: 'Sans-serif & Sans-serif' },
              { id: 2, desc: 'Serif & Serif' },
              { id: 3, desc: 'Sans-serif & Serif' },
              { id: 4, desc: 'Serif & Sans-serif' },
              { id: 5, desc: 'Monospace & Monospace' },
              { id: 6, desc: 'Monospace & Sans-serif' },
              { id: 7, desc: 'Sans-serif & Monospace' },
              { id: 8, desc: 'Display & Sans-serif' },
              { id: 9, desc: 'Handwriting & Sans-serif' },
              { id: 10, desc: 'Display & Serif' },
              { id: 11, desc: 'Handwriting & Serif' },
              { id: 12, desc: 'Display & Monospace' },
              { id: 13, desc: 'Handwriting & Monospace' },
              { id: 14, desc: 'Display & Display' },
            ],
            styles: [
              {
                css: 'basetype-opensans.css',
                sectioncss: 'type-opensans.css',
                classname: 'type-opensans',
                img: '000.png',
                category: 9,
                default: !0,
                caption: 'Open Sans',
              },
              {
                css: 'basetype-spectralsc-karma.css',
                sectioncss: 'type-spectralsc-karma.css',
                classname: 'type-spectralsc-karma',
                img: '004.png',
                category: 2,
                default: !0,
                caption: 'Spectral SC & Karma',
              },
              {
                css: 'basetype-alegreyasanssc-hind.css',
                sectioncss: 'type-alegreyasanssc-hind.css',
                classname: 'type-alegreyasanssc-hind',
                img: '006.png',
                category: 1,
                default: !0,
                caption: 'Alegreya Sans SC & Hind',
              },
              {
                css: 'basetype-cabinsketch-montserrat.css',
                sectioncss: 'type-cabinsketch-montserrat.css',
                classname: 'type-cabinsketch-montserrat',
                img: '007.png',
                category: 8,
                default: !0,
                caption: 'Cabin Sketch & Montserrat',
              },
              {
                css: 'basetype-anonymouspro-catamaran.css',
                sectioncss: 'type-anonymouspro-catamaran.css',
                classname: 'type-anonymouspro-catamaran',
                img: '010.png',
                category: 6,
                default: !0,
                caption: 'Anonymous Pro & Catamaran',
              },
              {
                css: 'basetype-nothingyouc-ibmplexmono.css',
                sectioncss: 'type-nothingyouc-ibmplexmono.css',
                classname: 'type-nothingyouc-ibmplexmono',
                img: '011.png',
                category: 13,
                default: !0,
                caption: 'Nothing You Could Do & IBM Plex Mono',
              },
              {
                css: 'basetype-juliussansone-taviraj.css',
                sectioncss: 'type-juliussansone-taviraj.css',
                classname: 'type-juliussansone-taviraj',
                img: '012.png',
                category: 3,
                default: !0,
                caption: 'Julius Sans One & Taviraj',
              },
              {
                css: 'basetype-voltaire-sourcecodepro.css',
                sectioncss: 'type-voltaire-sourcecodepro.css',
                classname: 'type-voltaire-sourcecodepro',
                img: '013.png',
                category: 7,
                default: !0,
                caption: 'Voltaire & Source Code Pro',
              },
              {
                css: 'basetype-oregano-zillaslab.css',
                sectioncss: 'type-oregano-zillaslab.css',
                classname: 'type-oregano-zillaslab',
                img: '014.png',
                category: 10,
                default: !0,
                caption: 'Oregano & Zilla Slab',
              },
              {
                css: 'basetype-anonymouspro.css',
                sectioncss: 'type-anonymouspro.css',
                classname: 'type-anonymouspro',
                img: '016.png',
                category: 5,
                default: !1,
                caption: 'Anonymous Pro',
              },
              {
                css: 'basetype-dancingscript-anonymouspro.css',
                sectioncss: 'type-dancingscript-anonymouspro.css',
                classname: 'type-dancingscript-anonymouspro',
                img: '018.png',
                category: 13,
                default: !1,
                caption: 'Dancing Script & Anonymous Pro',
              },
              {
                css: 'basetype-unicaone-cormorantgaramond.css',
                sectioncss: 'type-unicaone-cormorantgaramond.css',
                classname: 'type-unicaone-cormorantgaramond',
                img: '019.png',
                category: 10,
                default: !1,
                caption: 'Unica One & Cormorant Garamond',
              },
              {
                css: 'basetype-allan-overpassmono.css',
                sectioncss: 'type-allan-overpassmono.css',
                classname: 'type-allan-overpassmono',
                img: '020.png',
                category: 12,
                default: !1,
                caption: 'Allan & Overpass Mono',
              },
              {
                css: 'basetype-averialibre-barlow.css',
                sectioncss: 'type-averialibre-barlow.css',
                classname: 'type-averialibre-barlow',
                img: '021.png',
                category: 8,
                default: !1,
                caption: 'Averia Libre & Barlow',
              },
              {
                css: 'basetype-merriweathersans-martel.css',
                sectioncss: 'type-merriweathersans-martel.css',
                classname: 'type-merriweathersans-martel',
                img: '022.png',
                category: 3,
                default: !1,
                caption: 'Merriweather Sans & Martel',
              },
              {
                css: 'basetype-poppins.css',
                sectioncss: 'type-poppins.css',
                classname: 'type-poppins',
                img: '023.png',
                category: 1,
                default: !1,
                caption: 'Poppins',
              },
              {
                css: 'basetype-specialelite-encodesans.css',
                sectioncss: 'type-specialelite-encodesans.css',
                classname: 'type-specialelite-encodesans',
                img: '026.png',
                category: 8,
                default: !1,
                caption: 'Special Elite & Encode Sans',
              },
              {
                css: 'basetype-marcellussc-heebo.css',
                sectioncss: 'type-marcellussc-heebo.css',
                classname: 'type-marcellussc-heebo',
                img: '028.png',
                category: 4,
                default: !1,
                caption: 'Marcellus SC & Heebo',
              },
              {
                css: 'basetype-oswald-cousine.css',
                sectioncss: 'type-oswald-cousine.css',
                classname: 'type-oswald-cousine',
                img: '029.png',
                category: 7,
                default: !1,
                caption: 'Oswald & Cousine',
              },
              {
                css: 'basetype-oranienbaum-sourcesanspro.css',
                sectioncss: 'type-oranienbaum-sourcesanspro.css',
                classname: 'type-oranienbaum-sourcesanspro',
                img: '031.png',
                category: 4,
                default: !1,
                caption: 'Oranienbaum & Source Sans Pro',
              },
              {
                css: 'basetype-sriracha-arvo.css',
                sectioncss: 'type-sriracha-arvo.css',
                classname: 'type-sriracha-arvo',
                img: '032.png',
                category: 11,
                default: !1,
                caption: 'Sriracha & Arvo',
              },
              {
                css: 'basetype-merriweather.css',
                sectioncss: 'type-merriweather.css',
                classname: 'type-merriweather',
                img: '033.png',
                category: 2,
                default: !1,
                caption: 'Merriweather',
              },
              {
                css: 'basetype-badscript-rokkitt.css',
                sectioncss: 'type-badscript-rokkitt.css',
                classname: 'type-badscript-rokkitt',
                img: '034.png',
                category: 11,
                default: !1,
                caption: 'Bad Script & Rokkitt',
              },
              {
                css: 'basetype-inconsolata.css',
                sectioncss: 'type-inconsolata.css',
                classname: 'type-inconsolata',
                img: '036.png',
                category: 5,
                default: !1,
                caption: 'Inconsolata',
              },
              {
                css: 'basetype-novamono-robotomono.css',
                sectioncss: 'type-novamono-robotomono.css',
                classname: 'type-novamono-robotomono',
                img: '037.png',
                category: 5,
                default: !1,
                caption: 'Nova Mono & Roboto Mono',
              },
              {
                css: 'basetype-spacemono.css',
                sectioncss: 'type-spacemono.css',
                classname: 'type-spacemono',
                img: '038.png',
                category: 5,
                default: !1,
                caption: 'Space Mono',
              },
              {
                css: 'basetype-elsie-frankruhllibre.css',
                sectioncss: 'type-elsie-frankruhllibre.css',
                classname: 'type-elsie-frankruhllibre',
                img: '042.png',
                category: 10,
                default: !1,
                caption: 'Elsie & Frank Ruhl Libre',
              },
              {
                css: 'basetype-playfairdisp-petitformalscr.css',
                sectioncss: 'type-playfairdisp-petitformalscr.css',
                classname: 'type-playfairdisp-petitformalscr',
                img: '043.png',
                category: 2,
                default: !1,
                caption: 'Playfair Display',
              },
              {
                css: 'basetype-josefinsans-neuton.css',
                sectioncss: 'type-josefinsans-neuton.css',
                classname: 'type-josefinsans-neuton',
                img: '044.png',
                category: 3,
                default: !1,
                caption: 'Josefin Sans & Neuton',
              },
              {
                css: 'basetype-stintultracon-inconsolata.css',
                sectioncss: 'type-stintultracon-inconsolata.css',
                classname: 'type-stintultracon-inconsolata',
                img: '045.png',
                category: 12,
                default: !1,
                caption: 'Stint Ultra Condensed & Inconsolata',
              },
              {
                css: 'basetype-raleway-playfairdisplay.css',
                sectioncss: 'type-raleway-playfairdisplay.css',
                classname: 'type-raleway-playfairdisplay',
                img: '047.png',
                category: 1,
                default: !1,
                caption: 'Raleway',
              },
              {
                css: 'basetype-ubuntumono-sourcecodepro.css',
                sectioncss: 'type-ubuntumono-sourcecodepro.css',
                classname: 'type-ubuntumono-sourcecodepro',
                img: '049.png',
                category: 5,
                default: !1,
                caption: 'Ubuntu Mono & Source Code Pro',
              },
              {
                css: 'basetype-sharetechmono-nunito.css',
                sectioncss: 'type-sharetechmono-nunito.css',
                classname: 'type-sharetechmono-nunito',
                img: '050.png',
                category: 6,
                default: !1,
                caption: 'Share Tech Mono & Nunito',
              },
              {
                css: 'basetype-lato.css',
                sectioncss: 'type-lato.css',
                classname: 'type-lato',
                img: '051.png',
                category: 1,
                default: !1,
                caption: 'Lato',
              },
              {
                css: 'basetype-pathwaygothicone-merriweather.css',
                sectioncss: 'type-pathwaygothicone-merriweather.css',
                classname: 'type-pathwaygothicone-merriweather',
                img: '052.png',
                category: 3,
                default: !1,
                caption: 'Pathway Gothic One & Merriweather',
              },
              {
                css: 'basetype-forum-nanumgothiccoding.css',
                sectioncss: 'type-forum-nanumgothiccoding.css',
                classname: 'type-forum-nanumgothiccoding',
                img: '053.png',
                category: 12,
                default: !1,
                caption: 'Forum & Nanum Gothic Coding',
              },
              {
                css: 'basetype-bilbo-halant.css',
                sectioncss: 'type-bilbo-halant.css',
                classname: 'type-bilbo-halant',
                img: '054.png',
                category: 11,
                default: !1,
                caption: 'Bilbo & Halant',
              },
              {
                css: 'basetype-hammersmithone-poppins.css',
                sectioncss: 'type-hammersmithone-poppins.css',
                classname: 'type-hammersmithone-poppins',
                img: '057.png',
                category: 1,
                default: !1,
                caption: 'Hammersmith One & Poppins',
              },
              {
                css: 'basetype-arimamadurai.css',
                sectioncss: 'type-arimamadurai.css',
                classname: 'type-arimamadurai',
                img: '058.png',
                category: 14,
                default: !1,
                caption: 'Arima Madurai',
              },
              {
                css: 'basetype-teko-muktamahee.css',
                sectioncss: 'type-teko-muktamahee.css',
                classname: 'type-teko-muktamahee',
                img: '059.png',
                category: 1,
                default: !1,
                caption: 'Teko & Mukta Mahee',
              },
              {
                css: 'basetype-heebo-ibmplexmono.css',
                sectioncss: 'type-heebo-ibmplexmono.css',
                classname: 'type-heebo-ibmplexmono',
                img: '060.png',
                category: 7,
                default: !1,
                caption: 'Heebo & IBM Plex Mono',
              },
              {
                css: 'basetype-sairacon-thegirlnextdoor.css',
                sectioncss: 'type-sairacon-thegirlnextdoor.css',
                classname: 'type-sairacon-thegirlnextdoor',
                img: '062.png',
                category: 1,
                default: !1,
                caption: 'Saira Condensed',
              },
              {
                css: 'basetype-frankruhllibre-lato.css',
                sectioncss: 'type-frankruhllibre-lato.css',
                classname: 'type-frankruhllibre-lato',
                img: '063.png',
                category: 4,
                default: !1,
                caption: 'Frank Ruhl Libre & Lato',
              },
              {
                css: 'basetype-yantramanav-ibmplexserif.css',
                sectioncss: 'type-yantramanav-ibmplexserif.css',
                classname: 'type-yantramanav-ibmplexserif',
                img: '064.png',
                category: 1,
                default: !1,
                caption: 'Yantramanav & IBM Plex Serif',
              },
              {
                css: 'basetype-quicksand-kalam.css',
                sectioncss: 'type-quicksand-kalam.css',
                classname: 'type-quicksand-kalam',
                img: '065.png',
                category: 1,
                default: !1,
                caption: 'Quicksand & Kalam',
              },
              {
                css: 'basetype-ibmplexmono.css',
                sectioncss: 'type-ibmplexmono.css',
                classname: 'type-ibmplexmono',
                img: '066.png',
                category: 5,
                default: !1,
                caption: 'IBM Plex Mono',
              },
              {
                css: 'basetype-cinzeldecor-palanquin.css',
                sectioncss: 'type-cinzeldecor-palanquin.css',
                classname: 'type-cinzeldecor-palanquin',
                img: '067.png',
                category: 8,
                default: !1,
                caption: 'Cinzel Decorative & Palanquin',
              },
              {
                css: 'basetype-oswald-biryani.css',
                sectioncss: 'type-oswald-biryani.css',
                classname: 'type-oswald-biryani',
                img: '069.png',
                category: 1,
                default: !1,
                caption: 'Oswald & Biryani',
              },
              {
                css: 'basetype-yanonekaff-josefinsans.css',
                sectioncss: 'type-yanonekaff-josefinsans.css',
                classname: 'type-yanonekaff-josefinsans',
                img: '070.png',
                category: 1,
                default: !1,
                caption: 'Yanone Kaffeesatz & Josefin Sans',
              },
              {
                css: 'basetype-abrilfatface-assistant.css',
                sectioncss: 'type-abrilfatface-assistant.css',
                classname: 'type-abrilfatface-assistant',
                img: '071.png',
                category: 8,
                default: !1,
                caption: 'Abril Fatface & Assistant',
              },
              {
                css: 'basetype-nanumgothiccod-firasanscon.css',
                sectioncss: 'type-nanumgothiccod-firasanscon.css',
                classname: 'type-nanumgothiccod-firasanscon',
                img: '072.png',
                category: 6,
                default: !1,
                caption: 'Nanum Gothic Coding & Fira Sans Condensed',
              },
              {
                css: 'basetype-inder-trirong.css',
                sectioncss: 'type-inder-trirong.css',
                classname: 'type-inder-trirong',
                img: '073.png',
                category: 3,
                default: !1,
                caption: 'Inder & Trirong',
              },
              {
                css: 'basetype-atma-tajawal.css',
                sectioncss: 'type-atma-tajawal.css',
                classname: 'type-atma-tajawal',
                img: '075.png',
                category: 8,
                default: !1,
                caption: 'Atma & Tajawal',
              },
              {
                css: 'basetype-prata-hindsiliguri.css',
                sectioncss: 'type-prata-hindsiliguri.css',
                classname: 'type-prata-hindsiliguri',
                img: '076.png',
                category: 4,
                default: !1,
                caption: 'Prata & Hind Siliguri',
              },
              {
                css: 'basetype-federo-gothica1.css',
                sectioncss: 'type-federo-gothica1.css',
                classname: 'type-federo-gothica1',
                img: '078.png',
                category: 1,
                default: !1,
                caption: 'Federo & Gothic A1',
              },
              {
                css: 'basetype-fjallaone-ibmplexserif.css',
                sectioncss: 'type-fjallaone-ibmplexserif.css',
                classname: 'type-fjallaone-ibmplexserif',
                img: '079.png',
                category: 3,
                default: !1,
                caption: 'Fjalla One & IBM Plex Serif',
              },
              {
                css: 'basetype-cormorantsc-ibmplexsanscon.css',
                sectioncss: 'type-cormorantsc-ibmplexsanscon.css',
                classname: 'type-cormorantsc-ibmplexsanscon',
                img: '081.png',
                category: 4,
                default: !1,
                caption: 'Cormorant SC & IBM Plex Sans Condensed',
              },
              {
                css: 'basetype-kalam-robotomono.css',
                sectioncss: 'type-kalam-robotomono.css',
                classname: 'type-kalam-robotomono',
                img: '082.png',
                category: 13,
                default: !1,
                caption: 'Kalam & Roboto Mono',
              },
              {
                css: 'basetype-fugazone-librefranklin.css',
                sectioncss: 'type-fugazone-librefranklin.css',
                classname: 'type-fugazone-librefranklin',
                img: '083.png',
                category: 8,
                default: !1,
                caption: 'Fugaz One & Libre Franklin',
              },
              {
                css: 'basetype-yeonsung-palanquin.css',
                sectioncss: 'type-yeonsung-palanquin.css',
                classname: 'type-yeonsung-palanquin',
                img: '085.png',
                category: 8,
                default: !1,
                caption: 'Yeon Sung & Palanquin',
              },
              {
                css: 'basetype-rancho-robotoslab.css',
                sectioncss: 'type-rancho-robotoslab.css',
                classname: 'type-rancho-robotoslab',
                img: '086.png',
                category: 11,
                default: !1,
                caption: 'Rancho & Roboto Slab',
              },
              {
                css: 'basetype-tenaram-overpassmono.css',
                sectioncss: 'type-tenaram-overpassmono.css',
                classname: 'type-tenaram-overpassmono',
                img: '087.png',
                category: 7,
                default: !1,
                caption: 'Tenali Ramakrishna & Overpass Mono',
              },
              {
                css: 'basetype-thegirlnextdoor-sourcesanspro.css',
                sectioncss: 'type-thegirlnextdoor-sourcesanspro.css',
                classname: 'type-thegirlnextdoor-sourcesanspro',
                img: '088.png',
                category: 9,
                default: !1,
                caption: 'The Girl Next Door & Source Sans Pro',
              },
              {
                css: 'basetype-boogaloo-inconsolata.css',
                sectioncss: 'type-boogaloo-inconsolata.css',
                classname: 'type-boogaloo-inconsolata',
                img: '090.png',
                category: 12,
                default: !1,
                caption: 'Boogaloo & Inconsolata',
              },
              {
                css: 'basetype-caveat-sourcecodepro.css',
                sectioncss: 'type-caveat-sourcecodepro.css',
                classname: 'type-caveat-sourcecodepro',
                img: '091.png',
                category: 13,
                default: !1,
                caption: 'Caveat & Source Code Pro',
              },
              {
                css: 'basetype-passionone-worksans.css',
                sectioncss: 'type-passionone-worksans.css',
                classname: 'type-passionone-worksans',
                img: '092.png',
                category: 8,
                default: !1,
                caption: 'Passion One & Work Sans',
              },
              {
                css: 'basetype-anticdidone-halant.css',
                sectioncss: 'type-anticdidone-halant.css',
                classname: 'type-anticdidone-halant',
                img: '093.png',
                category: 2,
                default: !1,
                caption: 'Antic Didone & Halant',
              },
              {
                css: 'basetype-adventpro-opensans.css',
                sectioncss: 'type-adventpro-opensans.css',
                classname: 'type-adventpro-opensans',
                img: '094.png',
                category: 1,
                default: !1,
                caption: 'Advent Pro & Open Sans',
              },
              {
                css: 'basetype-cutivemono-lato.css',
                sectioncss: 'type-cutivemono-lato.css',
                classname: 'type-cutivemono-lato',
                img: '095.png',
                category: 6,
                default: !1,
                caption: 'Cutive Mono & Lato',
              },
              {
                css: 'basetype-elsie-montserrat.css',
                sectioncss: 'type-elsie-montserrat.css',
                classname: 'type-elsie-montserrat',
                img: '096.png',
                category: 8,
                default: !1,
                caption: 'Elsie & Montserrat',
              },
              {
                css: 'basetype-macondo-mukta.css',
                sectioncss: 'type-macondo-mukta.css',
                classname: 'type-macondo-mukta',
                img: '097.png',
                category: 8,
                default: !1,
                caption: 'Macondo & Mukta',
              },
              {
                css: 'basetype-oswald-opensans.css',
                sectioncss: 'type-oswald-opensans.css',
                classname: 'type-oswald-opensans',
                img: '098.png',
                category: 1,
                default: !1,
                caption: 'Oswald & Open Sans',
              },
              {
                css: 'basetype-poppins-lekton.css',
                sectioncss: 'type-poppins-lekton.css',
                classname: 'type-poppins-lekton',
                img: '099.png',
                category: 1,
                default: !1,
                caption: 'Poppins & Lekton',
              },
              {
                css: 'basetype-raleway-neuton.css',
                sectioncss: 'type-raleway-neuton.css',
                classname: 'type-raleway-neuton',
                img: '100.png',
                category: 3,
                default: !1,
                caption: 'Raleway & Neuton',
              },
              {
                css: 'basetype-sourcecodepro-nunitosans.css',
                sectioncss: 'type-sourcecodepro-nunitosans.css',
                classname: 'type-sourcecodepro-nunitosans',
                img: '101.png',
                category: 6,
                default: !1,
                caption: 'Source Code Pro & Nunito Sans',
              },
              {
                css: 'basetype-tangerine-opensans.css',
                sectioncss: 'type-tangerine-opensans.css',
                classname: 'type-tangerine-opensans',
                img: '102.png',
                category: 9,
                default: !1,
                caption: 'Tangerine & Open Sans',
              },
              {
                css: 'basetype-alegreya-lato.css',
                sectioncss: 'type-alegreya-lato.css',
                classname: 'type-alegreya-lato',
                img: '103.png',
                category: 4,
                default: !1,
                caption: 'Alegreya & Lato',
              },
              {
                css: 'basetype-amaticsc-lato.css',
                sectioncss: 'type-amaticsc-lato.css',
                classname: 'type-amaticsc-lato',
                img: '104.png',
                category: 9,
                default: !1,
                caption: 'Amatic SC & Lato',
              },
              {
                css: 'basetype-heebo-ibmplexmono-2.css',
                sectioncss: 'type-heebo-ibmplexmono-2.css',
                classname: 'type-heebo-ibmplexmono-2',
                img: '105.png',
                category: 7,
                default: !1,
                caption: 'Heebo & IBM Plex Mono',
              },
              {
                css: 'basetype-juliussansone-robotocondensed.css',
                sectioncss: 'type-juliussansone-robotocondensed.css',
                classname: 'type-juliussansone-robotocondensed',
                img: '106.png',
                category: 1,
                default: !1,
                caption: 'Julius Sans One & Roboto Condensed',
              },
              {
                css: 'basetype-montserrat-roboto.css',
                sectioncss: 'type-montserrat-roboto.css',
                classname: 'type-montserrat-roboto',
                img: '107.png',
                category: 1,
                default: !1,
                caption: 'Montserrat & Roboto',
              },
              {
                css: 'basetype-nothingyouc-ibmplexmono-2.css',
                sectioncss: 'type-nothingyouc-ibmplexmono-2.css',
                classname: 'type-nothingyouc-ibmplexmono-2',
                img: '108.png',
                category: 13,
                default: !1,
                caption: 'Nothing You Could Do & IBM Plex Mono',
              },
              {
                css: 'basetype-raleway-lato.css',
                sectioncss: 'type-raleway-lato.css',
                classname: 'type-raleway-lato',
                img: '109.png',
                category: 1,
                default: !1,
                caption: 'Raleway & Lato',
              },
              {
                css: 'basetype-raleway-lusitana.css',
                sectioncss: 'type-raleway-lusitana.css',
                classname: 'type-raleway-lusitana',
                img: '110.png',
                category: 3,
                default: !1,
                caption: 'Raleway & Lusitana',
              },
              {
                css: 'basetype-rufina-oxygen.css',
                sectioncss: 'type-rufina-oxygen.css',
                classname: 'type-rufina-oxygen',
                img: '111.png',
                category: 4,
                default: !1,
                caption: 'Rufina & Oxygen',
              },
              {
                css: 'basetype-sacramento-opensans.css',
                sectioncss: 'type-sacramento-opensans.css',
                classname: 'type-sacramento-opensans',
                img: '112.png',
                category: 9,
                default: !1,
                caption: 'Sacramento & Open Sans',
              },
              {
                css: 'basetype-specialelite-playfairdisplay.css',
                sectioncss: 'type-specialelite-playfairdisplay.css',
                classname: 'type-specialelite-playfairdisplay',
                img: '113.png',
                category: 10,
                default: !1,
                caption: 'Special Elite & Playfair Display',
              },
              {
                css: 'basetype-unicaone-sourcesanspro.css',
                sectioncss: 'type-unicaone-sourcesanspro.css',
                classname: 'type-unicaone-sourcesanspro',
                img: '114.png',
                category: 8,
                default: !1,
                caption: 'Unica One & Source Sans Pro',
              },
              {
                css: 'basetype-amaticsc-josepfinsans.css',
                sectioncss: 'type-amaticsc-josepfinsans.css',
                classname: 'type-amaticsc-josepfinsans',
                img: '001.png',
                category: 9,
                default: !0,
                caption: 'Amatic SC & Josefin Sans',
              },
              {
                css: 'basetype-sourcesanspro-anonymouspro.css',
                sectioncss: 'type-sourcesanspro-anonymouspro.css',
                classname: 'type-sourcesanspro-anonymouspro',
                img: '002.png',
                category: 7,
                default: !0,
                caption: 'Source Sans Pro & Anonymous Pro',
              },
              {
                css: 'basetype-poppins-oldstandardtt.css',
                sectioncss: 'type-poppins-oldstandardtt.css',
                classname: 'type-poppins-oldstandardtt',
                img: '003.png',
                category: 3,
                default: !0,
                caption: 'Poppins & Old Standard TT',
              },
              {
                css: 'basetype-yesteryear-chivo.css',
                sectioncss: 'type-yesteryear-chivo.css',
                classname: 'type-yesteryear-chivo',
                img: '005.png',
                category: 9,
                default: !0,
                caption: 'Yesteryear & Chivo',
              },
              {
                css: 'basetype-ptserif-poppins.css',
                sectioncss: 'type-ptserif-poppins.css',
                classname: 'type-ptserif-poppins',
                img: '008.png',
                category: 4,
                default: !0,
                caption: 'PT Serif & Poppins',
              },
              {
                css: 'basetype-kellyslab-yantramanav.css',
                sectioncss: 'type-kellyslab-yantramanav.css',
                classname: 'type-kellyslab-yantramanav',
                img: '009.png',
                category: 8,
                default: !0,
                caption: 'Kelly Slab & Yantramanav',
              },
              {
                css: 'basetype-yellowtail-frankruhllibre.css',
                sectioncss: 'type-yellowtail-frankruhllibre.css',
                classname: 'type-yellowtail-frankruhllibre',
                img: '015.png',
                category: 11,
                default: !0,
                caption: 'Yellowtail & Frank Ruhl Libre',
              },
              {
                css: 'basetype-sedgwickave-spectral.css',
                sectioncss: 'type-sedgwickave-spectral.css',
                classname: 'type-sedgwickave-spectral',
                img: '017.png',
                category: 10,
                default: !1,
                caption: 'Sedgwick Ave & Spectral',
              },
              {
                css: 'basetype-satisfy-economica.css',
                sectioncss: 'type-satisfy-economica.css',
                classname: 'type-satisfy-economica',
                img: '024.png',
                category: 9,
                default: !1,
                caption: 'Satisfy & Economica',
              },
              {
                css: 'basetype-josefinsans-lekton.css',
                sectioncss: 'type-josefinsans-lekton.css',
                classname: 'type-josefinsans-lekton',
                img: '025.png',
                category: 1,
                default: !1,
                caption: 'Josefin Sans & Lekton',
              },
              {
                css: 'basetype-parisienne-maitree.css',
                sectioncss: 'type-parisienne-maitree.css',
                classname: 'type-parisienne-maitree',
                img: '027.png',
                category: 11,
                default: !1,
                caption: 'Parisienne & Maitree',
              },
              {
                css: 'basetype-londrinashadow-martel.css',
                sectioncss: 'type-londrinashadow-martel.css',
                classname: 'type-londrinashadow-martel',
                img: '030.png',
                category: 10,
                default: !1,
                caption: 'Londrina Shadow & Martel',
              },
              {
                css: 'basetype-poiretone-pridi.css',
                sectioncss: 'type-poiretone-pridi.css',
                classname: 'type-poiretone-pridi',
                img: '035.png',
                category: 10,
                default: !1,
                caption: 'Poiret One & Pridi',
              },
              {
                css: 'basetype-pollerone-ibmplexserif.css',
                sectioncss: 'type-pollerone-ibmplexserif.css',
                classname: 'type-pollerone-ibmplexserif',
                img: '039.png',
                category: 10,
                default: !1,
                caption: 'Poller One & IBM Plex Serif',
              },
              {
                css: 'basetype-italiana-martel.css',
                sectioncss: 'type-italiana-martel.css',
                classname: 'type-italiana-martel',
                img: '040.png',
                category: 2,
                default: !1,
                caption: 'Italiana & Martel',
              },
              {
                css: 'basetype-julee-lora.css',
                sectioncss: 'type-julee-lora.css',
                classname: 'type-julee-lora',
                img: '041.png',
                category: 11,
                default: !1,
                caption: 'Julee & Lora',
              },
              {
                css: 'basetype-sixcaps-robotomono.css',
                sectioncss: 'type-sixcaps-robotomono.css',
                classname: 'type-sixcaps-robotomono',
                img: '046.png',
                category: 7,
                default: !1,
                caption: 'Six Caps & Roboto Mono',
              },
              {
                css: 'basetype-pacifico-nanumgothiccod.css',
                sectioncss: 'type-pacifico-nanumgothiccod.css',
                classname: 'type-pacifico-nanumgothiccod',
                img: '048.png',
                category: 13,
                default: !1,
                caption: 'Pacifico & Nanum Gothic Coding',
              },
              {
                css: 'basetype-greatvibes-robotomono.css',
                sectioncss: 'type-greatvibes-robotomono.css',
                classname: 'type-greatvibes-robotomono',
                img: '055.png',
                category: 13,
                default: !1,
                caption: 'Great Vibes & Roboto Mono',
              },
              {
                css: 'basetype-pinyonscript-firasans.css',
                sectioncss: 'type-pinyonscript-firasans.css',
                classname: 'type-pinyonscript-firasans',
                img: '056.png',
                category: 9,
                default: !1,
                caption: 'Pinyon Script & Fira Sans',
              },
              {
                css: 'basetype-sail-rasa.css',
                sectioncss: 'type-sail-rasa.css',
                classname: 'type-sail-rasa',
                img: '061.png',
                category: 10,
                default: !1,
                caption: 'Sail & Rasa',
              },
              {
                css: 'basetype-yesevaone-forum.css',
                sectioncss: 'type-yesevaone-forum.css',
                classname: 'type-yesevaone-forum',
                img: '068.png',
                category: 14,
                default: !1,
                caption: 'Yeseva One & Forum',
              },
              {
                css: 'basetype-dosis-oldstandardtt.css',
                sectioncss: 'type-dosis-oldstandardtt.css',
                classname: 'type-dosis-oldstandardtt',
                img: '074.png',
                category: 1,
                default: !1,
                caption: 'Dosis & Old Standard TT',
              },
              {
                css: 'basetype-engagement-spectral.css',
                sectioncss: 'type-engagement-spectral.css',
                classname: 'type-engagement-spectral',
                img: '077.png',
                category: 11,
                default: !1,
                caption: 'Engagement & Spectral',
              },
              {
                css: 'basetype-dynalight-mada.css',
                sectioncss: 'type-dynalight-mada.css',
                classname: 'type-dynalight-mada',
                img: '080.png',
                category: 8,
                default: !1,
                caption: 'Dynalight & Mada',
              },
              {
                css: 'basetype-gravitasone-nanummyeongjo.css',
                sectioncss: 'type-gravitasone-nanummyeongjo.css',
                classname: 'type-gravitasone-nanummyeongjo',
                img: '084.png',
                category: 10,
                default: !1,
                caption: 'Gravitas One & Nanum Myeongjo',
              },
              {
                css: 'basetype-alexbrush-ibmplexsans.css',
                sectioncss: 'type-alexbrush-ibmplexsans.css',
                classname: 'type-alexbrush-ibmplexsans',
                img: '089.png',
                category: 9,
                default: !1,
                caption: 'Alex Brush & IBM Plex Sans',
              },
            ],
          },
        },
      });

      // Example of adding buttons on the sidebar
      this.obj.addButton({
        pos: 2, // button position
        title: 'Undo', // title
        html: '<svg class="is-icon-flex" style="width:14px;height:14px;"><use xlink:href="#ion-ios-undo"></use></svg>', // icon
        onClick: () => {
          this.obj.undo();
        },
      });

      this.obj.addButton({
        pos: 3, // button position
        title: 'Redo', // title
        html: '<svg class="is-icon-flex" style="width:14px;height:14px;"><use xlink:href="#ion-ios-redo"></use></svg>', // icon
        onClick: () => {
          this.obj.redo();
        },
      });

      this.obj.addButton({
        pos: 5,
        title: 'Animation',
        html: '<svg class="is-icon-flex" style="fill:rgba(0, 0, 0, 0.7);width:14px;height:14px;"><use xlink:href="#icon-wand"></use></svg>', // icon
        onClick: () => {
          this.obj.openAnimationPanel();
        },
      });
      this.obj.addButton({
        pos: 6,
        title: 'Settings',
        html: '<svg class="is-icon-flex" style="width:15px;height:15px;"><use xlink:href="#icon-settings"></use></svg>', // icon
        onClick: () => {
          this.obj.openSettings();
        },
      });

      this.obj.addButton({
        pos: 7, // button position
        title: 'Preview', // title
        html: '<svg class="is-icon-flex" style="width:16px;height:16px;"><use xlink:href="#ion-eye"></use></svg>', // icon
        onClick: () => {
          let html = this.obj.html();
          localStorage.setItem('preview-html', html);
          let mainCss = this.obj.mainCss();
          localStorage.setItem('preview-maincss', mainCss);
          let sectionCss = this.obj.sectionCss();
          localStorage.setItem('preview-sectioncss', sectionCss);

          window.open('/preview.html', '_blank').focus();
        },
      });

      this.obj.addButton({
        pos: 8,
        title: 'AI Assistant',
        html: '<svg class="is-icon-flex" style="width:16px;height:16px;"><use xlink:href="#icon-message"></use></svg>',
        onClick: () => {
          this.obj.openAIAssistant();
        },
      });

      addExternalScripts([
        '/box/box-flex.js',
        '/assets/scripts/glide/glide.js',
        '/assets/scripts/navbar/navbar.min.js',
      ]);

      if (this.props.doObj) {
        console.log('doObj', this.obj);
        this.props.doObj(this.obj); // Make it available to be called using doObj
      }
    });

    // https://stackoverflow.com/questions/37949981/call-child-method-from-parent
    if (this.props.doSave) this.props.doSave(this.saveContent); // Make it available to be called using doSave
    if (this.props.doSaveAndFinish)
      this.props.doSaveAndFinish(this.saveContentAndFinish);
  }

  componentDidMount() {
    new EditPanel({
      // Helper to create iframe panel.
      src: 'samplecontent.html', // A must (content page inside iframe)
      page: '.is-wrapper',
      onReady: (ifr) => {
        this.iframe = ifr;

        this.startEditing(ifr);

        // Load content from server
        fetch('/load')
          .then((response) => response.json())
          .then((response) => {
            const html = response.html;
            const mainCss = response.mainCss;
            const sectionCss = response.sectionCss;

            this.obj.loadHtml(html); // Load html
            this.obj.loadStyles(mainCss, sectionCss); // Load styles

            const wrapper =
              this.iframe.contentDocument.querySelector('.is-wrapper');

            // To show up content smoothly, use transition.
            wrapper.style.transition = 'all 100ms ease';
            setTimeout(() => {
              wrapper.style.opacity = '';
              setTimeout(() => {
                wrapper.style.transition = '';
                wrapper.style.opacity = '1';
              }, 100);
            }, 100);

            // For viewing the content, call pageReRender() (from box-flex.js include)
            var iframeWindow = this.iframe.contentWindow;
            iframeWindow.pageReRender();
          });
      },
    });
  }

  loadLanguageFile(languageFile, callback) {
    if (!this.isScriptAlreadyIncluded(languageFile)) {
      const script = document.createElement('script');
      script.src = languageFile;
      script.async = true;
      script.onload = () => {
        if (callback) callback();
      };
      document.body.appendChild(script);
    } else {
      if (callback) callback();
    }
  }

  isScriptAlreadyIncluded(src) {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++)
      if (scripts[i].getAttribute('src') === src) return true;
    return false;
  }

  async uploadFile(e, callback) {
    const selectedFile = e.target.files[0];

    const formData = new FormData();
    formData.append('file', selectedFile);
    const resp = await uploadFileStatic(formData);
    if (resp?.code === 0) {
      callback({ url: resp?.result?.files[0] });
    }
  }

  save(callback) {
    // Save all embedded base64 images first
    this.obj.saveImages(
      '',
      () => {
        if (!this.obj) return; //in case destroyed during autosave, cancel the saving

        // Then save the content

        let html = this.obj.html();
        let mainCss = this.obj.mainCss(); // Returns the default typography style for the page
        let sectionCss = this.obj.sectionCss(); // Returns the typography styles for specific sections on the page

        callback(html, mainCss, sectionCss);
      },
      async (img, base64, filename) => {
        if (!this.obj) return; //in case destroyed during autosave, cancel the saving

        // Upload base64 images
        const reqBody = { image: base64, filename: filename };
        // fetch('/uploadbase64', {
        //   method: 'POST',
        //   body: JSON.stringify(reqBody),
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        // })
        //   .then((response) => response.json())
        //   .then((response) => {
        //     if (!response.error) {
        //       const uploadedImageUrl = response.url;
        //       img.setAttribute('src', uploadedImageUrl); // Update image src
        //     }
        //   });
        const resp = await uploadBase64Image(reqBody);
        if (resp?.code === 0) {
          const uploadedImageUrl = resp?.result;
          img.setAttribute('src', uploadedImageUrl); // Update image src
        }
      }
    );
  }

  saveContent() {
    this.save((html, mainCss, sectionCss) => {
      this.props.onSave(html, mainCss, sectionCss);
    });
  }

  saveContentAndFinish() {
    this.save((html, mainCss, sectionCss) => {
      this.props.onSaveAndFinish(html, mainCss, sectionCss);
    });
  }

  render() {
    return <div className="is-wrapper"></div>;
  }

  componentWillUnmount() {
    this.obj.destroy();
    this.obj = null;
  }

  loadPage(html, mainCss, sectionCss) {
    this.obj.loadHtml(html);
    this.obj.loadStyles(mainCss, sectionCss);
  }
}

export default BuilderControl;
